'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ToggleableContext = require('../alloy-toggleable/ToggleableContext.js');

var TabPanel = function (props) {
    var children = props.children, hideInactive = props.hideInactive, tabId = props.tabId, rest = tslib.__rest(props, ["children", "hideInactive", "tabId"]);
    var ctx = react.useContext(ToggleableContext.default);
    var isActive = ctx.isActive(tabId);
    var hiddenClass = !isActive && hideInactive ? 'd-none' : '';
    return isActive || hideInactive ? (jsxRuntime.jsx("div", tslib.__assign({ role: "tabpanel", "aria-labelledby": "tab-".concat(tabId), className: hiddenClass, id: "tab-panel-".concat(tabId) }, rest, { children: children }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}));
};

exports.TabPanel = TabPanel;
//# sourceMappingURL=TabPanel.js.map
